export default __webpack_public_path__ + "c15718318ea26f1ee99b081855a4de9b.webp";